<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" class="text-center">
        <v-card v-if="loading" class="pa-5" elevation="3">
          <v-card-text>
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
              class="mb-4"
            ></v-progress-circular>
            <h3 class="text-h6 font-weight-bold">Memproses Login SSO...</h3>
            <p class="caption grey--text">
              Mohon tunggu sebentar, kami sedang menyiapkan sesi Anda.
            </p>
          </v-card-text>
        </v-card>

        <v-alert v-else type="error" outlined>
          <div class="d-flex flex-column">
            <span class="font-weight-bold">Gagal Login</span>
            <span class="mt-1">
              Tidak dapat memvalidasi sesi SSO. Token tidak ditemukan.
            </span>
            <v-btn color="error" text class="mt-3" @click="retryLogin">
              Coba Lagi
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Callback",
  data() {
    return {
      loading: true,
      isProcessing: false,
      CALLBACK_PROCESSING_KEY: "sso_callback_processing",
      CALLBACK_PROCESSED_KEY: "sso_callback_processed",
    };
  },
  mounted() {
    if (this.isProcessing) {
      console.warn("Already processing SSO callback - skipping");
      return;
    }

    const isAlreadyProcessing = sessionStorage.getItem(this.CALLBACK_PROCESSING_KEY);
    if (isAlreadyProcessing === "true") {
      console.warn("SSO callback already being processed in another instance - skipping");
      this.loading = false;
      return;
    }

    const wasProcessed = sessionStorage.getItem(this.CALLBACK_PROCESSED_KEY);
    if (wasProcessed === "true") {
      console.warn("SSO callback already processed - redirecting to home");
      this.$router.replace("/login");
      return;
    }

    this.isProcessing = true;
    sessionStorage.setItem(this.CALLBACK_PROCESSING_KEY, "true");

    const token = this.$route.query.token;

    console.log("Token present:", !!token);

    if (token) {
      this.handleSuccess(token);
    } else {
      this.handleError();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem(this.CALLBACK_PROCESSING_KEY);
  },
  methods: {
    handleSuccess(token) {
      try {
        sessionStorage.setItem(this.CALLBACK_PROCESSED_KEY, "true");
        sessionStorage.removeItem(this.CALLBACK_PROCESSING_KEY);

        this.$store.dispatch("auth/detail", token);
      } catch (error) {
        console.error("Error processing SSO callback:", error);
        this.handleError();
      }
    },
    handleError() {
      this.loading = false;
      this.isProcessing = false;
      sessionStorage.removeItem(this.CALLBACK_PROCESSING_KEY);
      sessionStorage.removeItem(this.CALLBACK_PROCESSED_KEY);

      console.error("SSO callback failed - no tokens found");
    },
    retryLogin() {
      sessionStorage.removeItem(this.CALLBACK_PROCESSING_KEY);
      sessionStorage.removeItem(this.CALLBACK_PROCESSED_KEY);
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");

      this.$router.replace("/login");
    },
  },
};
</script>
